module.exports = __webpack_public_path__ + "img/a1.0f478922.png";